import React from "react";
import { Card, List, Image } from "antd";
import { observer } from "mobx-react";

function Photos({ photos = [] }) {
  return (
    <Card title={`Photos(${photos.length})`} style={{ width: "100vw" }}>
      <List
        style={{ maxHeight: "60vh", overflowY: "scroll" }}
        dataSource={photos}
        renderItem={(item) => (
          <Image
            key={`contact-img-${item.id}`}
            src={item.thumbImage}
            preview={{ src: item.mediumImage }}
            title={item.title}
            width={100}
            height={100}
            style={{ padding: 3 }}
          />
        )}
      />
    </Card>
  );
}

export default observer(Photos);
